import { api } from '../http';

export const fetchActiveEvent = () => api.get('/events/active');

export const fetchEvents = () => api.get('/events');

export const createEvent = data => api.post('/events', data);

export const updateEventStatus = (eventId, data) => api.patch(`/events/${eventId}`, data);
